import React, { useState, useRef, useEffect } from 'react';
import elevate from '../../assets/services/elevate/Screenshot 2025-03-27 132810-Picsart-AiImageEnhancer.png';
import impact1 from '../../assets/services/elevate/Screenshot 2025-03-22 141845.png';
import impact2 from '../../assets/services/elevate/Untitled design (31).png';
import { useNavigate } from 'react-router-dom';
import ScrollToHashElement from '../ScrollToHashElement'; // 👈 Import here

const ElevateSection = () => {
  const navigate = useNavigate();
  const [activeCard, setActiveCard] = useState(0);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);
  const touchEndX = useRef(null);
  const touchEndY = useRef(null);
  
  
    const carouselRef = useRef(null);
  
    // Handle touch events for swipe
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };
  
  
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
    touchEndY.current = e.touches[0].clientY;
  };
  
  const handleTouchEnd = () => {
    if (
      touchStartX.current === null ||
      touchEndX.current === null ||
      touchStartY.current === null ||
      touchEndY.current === null
    )
      return;
  
    const diffX = touchStartX.current - touchEndX.current;
    const diffY = touchStartY.current - touchEndY.current;
  
    // Check if horizontal movement is greater than vertical movement
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 5) {
      if (diffX > 0) {
        // Swipe left
        setActiveCard((prev) => (prev === 1 ? 0 : prev + 1));
      } else {
        // Swipe right
        setActiveCard((prev) => (prev === 0 ? 1 : prev - 1));
      }
    }
  
    touchStartX.current = null;
    touchEndX.current = null;
    touchStartY.current = null;
    touchEndY.current = null;
  };

  // Auto-scroll to active card
  // useEffect(() => {
  //   if (carouselRef.current) {
  //     carouselRef.current.scrollTo({
  //       left: activeCard * carouselRef.current.offsetWidth,
  //       behavior: 'smooth'
  //     });
  //   }
  // },
  // 
  //  [activeCard]);
    useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({
        left: activeCard * carouselRef.current.offsetWidth,
        behavior: 'smooth'
      });
    }
  }, [activeCard]);

  return (
    <div id="elevate" className="w-full bg-white mt-10 my-20 md:px-24 px-4">
      <h2 className="text-[#AD2F3B] text-[32px] font-bold max-[440px]:text-[20px] text-center mb-2">
        ELEVATE
      </h2>
      <p className="text-center text-[24px] font-semibold max-[440px]:text-[14px] text-gray-700 mb-[50px]">
        Cultural Entertainment
      </p>

      {/* Description Box */}
      <div className="flex gap-[50px] md:mx-24 flex-col md:flex-row max-[440px]:flex-col-reverse mb-20">
        <div className="border-2 h-[500px] border-gray-300 w-full max-[440px]:w-full max-[440px]:text-[14px] max-[440px]:py-10 rounded-[20px] px-8 pt-10 flex-1 text-[22px] font-medium leading-relaxed text-gray-900 shadow-[0_-8px_10px_-10px_rgba(0,0,0,0.3),0_8px_10px_-10px_rgba(0,0,0,0.3)]">
          <ul className="list-disc pl-4 space-y-8">
            <li>Curate unique cultural performances for private HNI events and elite gatherings at clubs and hotels</li>
            <li>Deliver uplifting  festive experiences for special occasions and celebrations.</li>
            <li>Collaborate with renowned folk and classical artists to create unforgettable moments.</li>
            <li>
              <span className="font-semibold">Clients:</span>Corporates, Luxury Hotels & Resorts, Elite Clubs, HNI Events
            </li>
          </ul>
        </div>

        {/* Image */}
        <div className="w-full md:w-[500px] h-[500px] max-[440px]:w-full max-[440px]:h-[395px] bg-gray-200">
          <img
            src={elevate}
            alt="Elevate Service"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Impact Highlights Section Box */}
      <div className="border-2 border-gray-300 py-10 text-[22px] text-gray-900 shadow-[0_-8px_10px_-10px_rgba(0,0,0,0.3),0_8px_10px_-10px_rgba(0,0,0,0.3)] w-full mx-auto mb-20 rounded-[20px] px-4 md:px-10 md:w-[1300px] md:mx-auto">
        <h3 className="text-[#AD2F3B] text-[30px] max-[440px]:text-[20px] font-bold text-center mb-12">
          Impact Highlights
        </h3>

        {/* Mobile Carousel */}
        <div className="md:hidden relative">
          <div 
            ref={carouselRef}
            className="flex overflow-x-hidden scroll-snap-x-mandatory scrollbar-hide"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {/* Card 1 */}
            <div className="w-full flex-shrink-0 px-2 scroll-snap-align-start">
              <div className="h-auto mb-10">
                <img
                  src={impact1}
                  alt="Goregaon Sports Club"
                  className="rounded-xl mb-4 w-full"
                  style={{ height: "auto", objectFit: "cover" }}
                />
                <h4 className="text-[#AD2F3B] text-[20px] font-bold mb-6 text-center">
                  Goregaon Sports Club (Mumbai)
                </h4>
              </div>
              <div className="space-y-8 text-left px-2 text-[14px]">
                <p>
                  <span className="font-semibold">Theme:</span> Annual “Diwali Pahaat” morning devotional concert
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Over 200 elite club members and guests celebrating Diwali.
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Enraptured  audience with rich classical and folk devotional song, music and dance performance for two successive years in 2023 and 2024.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="w-full flex-shrink-0 px-2 scroll-snap-align-start">
              <div className="h-auto mb-10">
                <img
                  src={impact2}
                  alt="High-profile Dinner"
                  className="rounded-xl mb-4 w-full"
                  style={{ height: "auto", objectFit: "cover" }}
                />
                <h4 className="text-[#AD2F3B] text-[20px] font-bold mb-6 text-center">
                  High-profile Private HNI Dinner (Gurgaon)
                </h4>
              </div>
              <div className="space-y-8 text-left px-2 text-[14px]">
                <p>
                  <span className="font-semibold">Theme:</span>High-energy Rajasthani folk entertainment for an elite private HNI  function at Grand Hyatt , Gurgaon
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Celebrity folk artists from Jaisalmer entertained over 100 HNI guests 
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Elevating and culturally vibrant entertainment for an unforgettable evening for guests.
                </p>
              </div>
            </div>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-6 space-x-3">
            {[0, 1].map((index) => (
              <button
                key={index}
                onClick={() => setActiveCard(index)}
                className={`w-4 h-4 rounded-full ${activeCard === index ? 'bg-[#AD2F3B]' : 'bg-gray-300'}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-col md:flex-row justify-between gap-[40px]">
          {/* Card 1 */}
          <div className="w-full md:w-[600px]">
            <div className="h-[400px] mb-10">
              <img
                src={impact1}
                alt="Goregaon Sports Club"
                className="rounded-xl mb-8 w-full"
                style={{ height: "300px", objectFit: "cover" }}
              />
              <h4 className="text-[#AD2F3B] text-[24px] font-bold mb-10 text-center">
                Goregaon Sports Club (Mumbai)
              </h4>
            </div>
            <div className="space-y-6 text-left px-4">
              <p>
                  <span className="font-semibold">Theme:</span> Annual “Diwali Pahaat” morning devotional concert
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Over 200 elite club members and guests celebrating Diwali.
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Enraptured  audience with rich classical and folk devotional song, music and dance performance for two successive years in 2023 and 2024.
                </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="w-full md:w-[600px]">
            <div className="h-[400px] mb-10">
              <img
                src={impact2}
                alt="High-profile Dinner"
                className="rounded-xl mb-8 w-full"
                style={{ height: "300px", objectFit: "cover" }}
              />
              <h4 className="text-[#AD2F3B] text-[24px] font-bold mb-10 text-center">
                High-profile Private HNI Dinner ( Gurgaon)
              </h4>
            </div>
            <div className="space-y-6 text-left px-4">
               <p>
                  <span className="font-semibold">Theme:</span>High-energy Rajasthani folk entertainment for an elite private HNI  function at Grand Hyatt , Gurgaon
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Celebrity folk artists from Jaisalmer entertained over 100 HNI guests 
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Elevating and culturally vibrant entertainment for an unforgettable evening for guests.
                </p>
            </div>
          </div>
        </div>
      </div>

      {/* Book Performance Button */}
<div className="flex justify-center items-center mt-16 mb-20">
  <button 
    onClick={() => navigate('/book-performance')} 
    className="bg-[#AD2F3B] text-white text-[18px] sm:text-[20px] rounded-full transition-shadow duration-300 hover:shadow-[0_6px_10px_rgba(0,0,0,0.25)] 
              w-[250px] h-[60px] 
              max-[440px]:w-[200px] max-[440px]:h-[45px] max-[440px]:text-[14px] max-[440px]:self-center"
  >
    Book Performance
  </button>
</div>

    </div>
  );
};

export default ElevateSection;